import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Stack, TextField, Alert, Box, Button } from "@mui/material";
import { post } from "aws-amplify/api";
import LoaderButton from "../components/LoaderButton";
import FormPage from "../components/FormPage";

export default function ResetUserPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const initial = (() => {
    if (location.state) {
      try {
        localStorage.setItem("resetUserId", location.state.userId);
        localStorage.setItem("resetEmail", location.state.email);
      } catch (e) { /* ignore */ }
      return { email: location.state.email, userId: location.state.userId };
    }
    try {
      return {
        userId: localStorage.getItem("resetUserId") ?? "",
        email: localStorage.getItem("resetEmail") ?? ""
      };
    } catch (e) {
      return { userId: "", email: "" };
    }
  })();

  const [isResetting, setIsResetting] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsResetting(true);
    setAlertMessage("");
    try {
      const op = post({
        apiName: "license",
        path: "/reset-password",
        options: { body: { userid: initial.userId } }
      });
      await op.response;
      navigate(-1);
    } catch (err) {
      setAlertMessage(err?.message ?? "Reset failed");
      setIsResetting(false);
    }
  };

  return (
    <FormPage
      title="Reset user password"
      subtitle="A temporary password will be emailed to the user. They'll be required to change it on next sign-in."
    >
      {alertMessage ? (
        <Alert severity="error" onClose={() => setAlertMessage("")}>{alertMessage}</Alert>
      ) : null}
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <Stack spacing={2.5}>
          <TextField
            label="Email"
            value={initial.email}
            type="email"
            InputProps={{ readOnly: true }}
          />
          <Stack direction="row" spacing={1.5}>
            <LoaderButton
              type="submit"
              isLoading={isResetting}
              text="Reset password"
              loadingText="Resetting…"
              fullWidth
            />
            <Button onClick={() => navigate(-1)} variant="outlined" disabled={isResetting} fullWidth>
              Cancel
            </Button>
          </Stack>
        </Stack>
      </Box>
    </FormPage>
  );
}
